import { render, staticRenderFns } from "./BaseTableHeading.vue?vue&type=template&id=e2122b3a&scoped=true&"
import script from "./BaseTableHeading.vue?vue&type=script&lang=js&"
export * from "./BaseTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableHeading.vue?vue&type=style&index=0&id=e2122b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2122b3a",
  null
  
)

export default component.exports